export const javelinConfig = {

  /** kolko m/s spomali za frame smerom hore */
  speedDecelerationUp: 0.992,

  /** kolko m/s zrychli za frame smerom dole */
  speedAccelerationDown: 1.008,

  /** gauss config */
  gaussConfig: {
    min: -10,
    max: 10,
    center: 0,
    difference: 6
  },

  /** nastavenie trasenia ostepu */
  shake: {

    // pri lete
    flying: {

      // prirastok za frame v ramci morph targets influences (0-1 moze byt hodnota)
      addValuePerFrame: 1,

      // postupnost indexov, ako pojde animacia trasenia - toto by sa nemalo menit
      indexes: [0, 1],

      // max hodnoty pre morph targets influences pre indexy vyssie, mozne hodnoty 0-1
      values: [0.3, 0.3]

    },

    // v zemi
    ground: {

      // prirastok za frame v ramci morph targets influences (0-1 moze byt hodnota)
      addValuePerFrame: 1 / 4,

      // postupnost indexov, ako pojde animacia trasenia
      indexes: [2, 3, 2, 3],

      // max hodnoty pre morph targets influences pre indexy vyssie, mozne hodnoty 0-1
      values: [1, 1, 0.9, 0.6]

    }

  }

}